import { useApiQuery } from "../services/react-query";

export const useGetEmailTemplatePreview = ({ templateName, eventId }) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["emailTemplatePreview", templateName, eventId],
      enabled: !!templateName,
    },
    fetchOptions: {
      url: `/email/template/${templateName}/preview`,
      method: "GET",
      params: eventId ? { eventId } : {},
    },
  });
